import { FC } from 'react'
import SelectController from './SelectController'
import { PaymentMethod } from '../../../generated'
import { enumToLabel } from '../../utils'

interface PaymentMethodControllerProps {
  name: string
  label: string
  paymentMethods: PaymentMethod[]
  required?: boolean
  disabled?: boolean
  /** Render the method list as a type-ahead (type, then Tab/Enter) instead of a plain Select. */
  searchable?: boolean
}

const PaymentMethodController: FC<PaymentMethodControllerProps> = ({
  disabled,
  label,
  required,
  paymentMethods,
  name,
  searchable
}) => {
  const options = Object.values(paymentMethods).map(method => ({
    label: method === PaymentMethod.Cheque ? 'Check' : enumToLabel(method),
    value: method
  }))

  return (
    <SelectController
      required={required}
      disabled={disabled}
      name={name}
      label={label}
      options={options}
      searchable={searchable}
    />
  )
}

export default PaymentMethodController
